import { getCookie } from 'cookies-next/client'

import { COOKIE_FROZEN_EXPA_NAME } from '../cookies'

export const expaGetClientSideFrozenExpaFromCookie = (): string | undefined => {
  return getCookie(COOKIE_FROZEN_EXPA_NAME)
}
